/**
*   Custom JS
*/

document.addEventListener('DOMContentLoaded', function () {
    const categorySliders = document.querySelectorAll('.js-sidebar-block-categories');

    if (categorySliders) {

        for (let index = 0; index < categorySliders.length; index++) {
            const slider = categorySliders[index];

            if (window.innerWidth < 768) {
                let flkty = new Flickity(slider, {
                    cellAlign: 'left',
                    freeScroll: true,
                    pageDots: false
                });

                window.addEventListener('resize', (event) => {
                    if (window.innerWidth > 767) {
                        console.log(flkty)
                        if (flkty) flkty.destroy();
                    }
                })
            }

        }


        /**
        *   ScrollTo Listeners for "Order Now" buttons
        *   - fixes issue in shogun where target="_blank" can't be removed
        */
        let orderNowButtons = document.querySelectorAll('[href="#ecom-control"');

        if (orderNowButtons) {
            orderNowButtons.forEach(button => button.target = '_self');
        }
    }

});